const Menu = [
  {
    path: "dashboard",
    icon: "fa fa-th",
    title: "Dashboard",
    children: [
      { path: "dashboard/v2", title: "Dashboard AI" },
    ],
  },
  
  {
    path: "/Calendar & Planning",
    icon: "fa fa-calendar text-yellow",
    title: "Calendar A & Planning",
    badge: "10",
    children: [
      { path: "/scheduler", title: "Scheduler" },
    ],
  },
  {
    path: "/ERP",
    icon: "fa fa-rectangle-list text-salmon",
    title: "ERP",
    children: [
       { path: "/ERP/COOitems", title: "Input item by Camera" },	    	    
       { path: "/ERP/COOitems", title: "Todays" },	    
       { path: "/ERP/COOitems", title: "COO Items" },
       { path: "/ERP/COOitemXLS", title: "COO Items XLS" },	    
       { path: "/ERP/COOitems", title: "Search in COOItems" },	    
	   { path: "/ERP/RVSs", title: "Repair Vendors Supplier List" },
      { path: "/ERP/outerboxbarcodeimages", title: "Outerbox codes" }
    ],
  },

{
	path: "/user",
	icon: "fa fa-lock text-orange",
	title: "Users",
	children: [
		{ path: "/uuserroles", title: "Admin User-Roles" },
		{ path: "/userroles/new", title: "Add User-Role" },			
		{ path: "/modulepermissions", title: "Admin Module-Permissions" },
		{ path: "/modulepermissions/new", title: "Add Module-Permission" },			
	],
},
	
  {
    path: "/Human Resources",
    icon: "fa fa-graduation-cap text-gray",
    title: "Human Resources",
    badge: "10",
    children: [
      { path: "/user/skills", title: "Skills" },
      { path: "/planning/admincertificates", title: "Admin of Certifications" },	  
      { path: "/user/shifts", title: "Shifts" },
      { path: "/user/leaves", title: "Leaves" },
      { path: "/user/attendances", title: "Attendances" },
      { path: "/planning/adminskills", title: "Admin Skills" },
      { path: "/planning/admincertificates", title: "Admin Certificates" },	  
      { path: "/user/adminshifts", title: "Admin Shifts" },
      { path: "/user/leaves", title: "Leaves" },
      { path: "/planning/leavesreasons", title: "Admin Leave-Reasons" },	  
      { path: "/planning/adminskills", title: "Admin Skills" },	  	  
      { path: "/user/qeshsupervisors", title: "QESH Supervisors" },	    
      { path: "/user/qeshsofficers", title: "QESH Officers" },	    	    
    ],
  },
   {
    path: "/AIML",
    icon: "far fa-brain text-gray",
    title: "AIML",
    children: [
	 { path: "/AIML/ImageAnnotations", title: "Settings" },    
	 { path: "/AIML/ImageAnnotations", title: "Text Annotation" },	
	 { path: "/AIML/ImageAnnotations", title: "Videos Annotation" },
	 { path: "/AIML/ImageAnnotations", title: "Audios Annotation" },	    
         { path: "/AIML/ImageAnnotations", title: "Data Annotation" },	
         { path: "/AIML/ImageAnnotations", title: "Images Annotation" },
         { path: "/metai/yourdrive", title: "Data Training" },	    
         { path: "/AIML/APIs", title: "APIs" },	        	    
         { path: "/AIML", title: "AI Service Providers List" },
         { path: "/AIML", title: "AI Service Providers" },
         { path: "/AIML", title: "AIssistants" },	        
         { path: "/AIML", title: "AIML Tasks" },	  
         { path: "/drive/yourdrive", title: "Your Drive" },	    
         { path: "AIML/LabelStudio", title: "Label Studio" },	    
    ],
  },	 
  {
    path: "/label",
    icon: "fa fa-barcode text-blue",
    title: "Barcode & Label",
    children: [
      { path: "/label/labels", title: "Labels" },
      { path: "/label/labels", title: "Input item" },	 
      { path: "/label/labelprint", title: "Print Label" },   
    ],
  },

  {
    path: "/QESH",
    icon: "fa fa-hospital text-mint",
    title: "QESH",
    children: [
      { path: "/QESH/capas", title: "CAPAs" },
    ],
  },	
	
  {
    path: "/ERP",
    icon: "fa fa-ERP1-custom",
    title: "ERP",
    children: [
      { path: "/ERP/COOItems", title: "COO Items" },
    ],
  },
  {
    path: "/Databases", icon: "fa fa-briefcase text-teal", title: "Databases",
    children: [
      { path: "/databases/titles", title: "Titles" },
      { path: "/databases/organizations", title: "Organizations" },
      { path: "/databases/banks", title: "Banks" },
      { path: "/databases/insurances", title: "Insurances" },
      { path: "/databases/reservedusernames", title: "Reserved Usernames" },
      { path: "/databases/termofuses/", title: "Term of USe" },
      { path: "/databases/privacypolicies/", title: "Privacy Policy" },
      { path: "/databases/meta", title: "Meta information" },	  
    ],
  },

  {
    path: "/workinstructions", icon: "fa fa-briefcase text-teal", title: "Work Instructions",
    children: [
      { path: "/workinstructions/ALUInbound", title: "MN-NI-Inbound" },
 	  { path: "/workinstructions/ALUOutbound", title: "MN-NI-Outbound" }, 	  
      { path: "/workinstructions/ALUOutboundCheatSheet", title: "ALU-Outbound-CheatSheet" },
      { path: "/workinstructions/ALUOutboundCheatSheet2", title: "ALU-Outbound-CheatSheet2" },	
      { path: "/workinstructions/RLC", title: "RLC" },		
      { path: "/workinstructions/OutboundGDC", title: "Outbound Nokia MN" },
      { path: "/workinstructions/RLCGoodsReceive", title: "RLC Goods Receive" },
	  { path: "/workinstructions/OTM", title: "OTM" },
 	  { path: "/workinstructions/password", title: "Password" },
      { path: "/workinstructions/Shipment", title: "Shipment" },	
 	  { path: "/workinstructions/confirmationdeliveries", title: "Confirmation of Deliveries" },
 	  { path: "/workinstructions/printerconfiguration", title: "PrinterConfiguration" },
	  { path: "/workinstructions/VL09", title: "VL09" },
      { path: "/workinstructions/workinstructions/new", title: "Add New WorkInstructions" },		
      { path: "/workinstructions/workinstructions/", title: "Work Instructions List" },
      { path: "/workinstructions/erinstructions/", title: "ER Instructions List" },      		
      { path: "/workinstructions/erinstructions/new", title: "Add New ER Instruction" },
    ],
  },
	
 {
    path: "/Ticket",
    icon: "fas fa-ticket-alt text-olive",
    title: "Tickets",
    badge: "10",
    children: [
      { path: "/ticket/tickets", title: "Tickets" },
      { path: "/ticket/tickets/new", title: "Add Ticket" },
      { path: "/ticket/grid-tickets", title: "Gridview of Tickets" },
      { path: "/ticket/timelinetickets", title: "Timeline of Tickets" },
      { path: "/ticket/search_tickets", title: "Search in Tickets" },
      { path: "/ticket/ticketcategories", title: "Ticket-categories" },	    
    ],
  },
	
  {
    path: "/chatbot",
    icon: "fas fa-ticket-alt text-indigo",
    title: "Chatbots",
    
    children: [
      { path: "/chatbot/setting", title: "Setting" },
      { path: "/chatbot/imexports", title: "Import Export Manager" },      
      { path: "/chatbot/conversations", title: "Conversations" },      
      { path: "/chatbot/companies", title: "Companies" },      
      { path: "/chatbot/APIs", title: "Manage APIs" },      	  
    ],
  },

{
	path: "/Users",
	icon: "fa fa-address-book text-tellow",
	title: "Office Apps",
	badge: "10",
	children: [
		
		{ path: "/user/users", title: "Word" },
		{ path: "/user/users", title: "Calculator" },			
		{ path: "/user/users", title: "New users" },			
	],
},

  { path: '/widgets', icon: 'fab fa-simplybuilt', title: 'Widgets', label: 'NEW' },
  { path: '/ui', icon: 'fa fa-gem', title: 'UI Elements', label: 'NEW',
    children: [
      { path: '/ui/general', title: 'General', highlight: true },
      { path: '/ui/typography', title: 'Typograhy' },
      { path: '/ui/tabs-accordion', title: 'Tabs & Accordion' },
      { path: '/ui/modal-notification', title: 'Modal & Notification' },
      { path: '/ui/widget-boxes', title: 'Widget Boxes' },
      { path: '/ui/media-object', title: 'Media Object' },
      { path: '/ui/buttons', title: 'Buttons', highlight: true },
      { path: '/ui/icon-fontawesome', title: 'FontAwesome' },
      { path: '/ui/icon-bootstrap', title: 'Bootstrap Icons', highlight: true },
      { path: '/ui/icon-simple-line-icons', title: 'Simple Line Icons' },
      { path: '/ui/language-bar-icon', title: 'Language Bar & Icon' },
      { path: '/ui/social-buttons', title: 'Social Buttons' }
    ]
  },
  { path: '/bootstrap-5', img: '/assets/img/logo/logo-bs5.png', title: 'Bootstrap 5', label: 'NEW' },
  { path: '/form', icon: 'fa fa-list-ol', title: 'Form Stuff', label: 'NEW',
    children: [
      { path: '/form/elements', title: 'Form Elements', highlight: true },
      { path: '/form/plugins', title: 'Form Plugins', highlight: true },
      { path: '/form/wizards', title: 'Form Wizards', highlight: true }
    ]
  },
  { path: '/table', icon: 'fa fa-table', title: 'Tables',
    children: [
      { path: '/table/elements', title: 'Table Elements' },
      { path: '/table/plugins', title: 'Table Plugins' }
    ]
  },
  { path: '/pos', icon: 'fa fa-cash-register', title: 'POS System', label: 'NEW',
    children: [
      { path: '/pos/customer-order', title: 'Customer Order' },
      { path: '/pos/kitchen-order', title: 'Kitchen Order' },
      { path: '/pos/counter-checkout', title: 'Counter Checkout' },
      { path: '/pos/table-booking', title: 'Table Booking' },
      { path: '/pos/menu-stock', title: 'Menu Stock' },
    ]
  },
  { path: '/chart', icon: 'fa fa-chart-pie', title: 'Chart', label: 'NEW',
    children: [
      { path: '/chart/js', title: 'Chart JS' },
      { path: '/chart/apex', title: 'Apex Chart', highlight: true }
    ]
  },

  { path: '/map', icon: 'fa fa-map', title: 'Map' },
  { path: '/gallery', icon: 'fa fa-image', title: 'Gallery' },
  { path: '/page-option', icon: 'fa fa-cogs', title: 'Page Options', label: 'NEW',
    children: [
      { path: '/page-option/blank', title: 'Blank Page' },
      { path: '/page-option/with-footer', title: 'Page with Footer' },
      { path: '/page-option/with-fixed-footer', title: 'Page with Fixed Footer', highlight: true },
      { path: '/page-option/without-sidebar', title: 'Page without Sidebar' },
      { path: '/page-option/with-right-sidebar', title: 'Page with Right Sidebar' },
      { path: '/page-option/with-minified-sidebar', title: 'Page with Minified Sidebar' },
      { path: '/page-option/with-two-sidebar', title: 'Page with Two Sidebar' },
      { path: '/page-option/full-height', title: 'Full Height Content' },
      { path: '/page-option/with-wide-sidebar', title: 'Page with Wide Sidebar' },
      { path: '/page-option/with-light-sidebar', title: 'Page with Light Sidebar' },
      { path: '/page-option/with-mega-menu', title: 'Page with Mega Menu' },
      { path: '/page-option/with-top-menu', title: 'Page with Top Menu' },
      { path: '/page-option/with-boxed-layout', title: 'Page with Boxed Layout' },
      { path: '/page-option/with-mixed-menu', title: 'Page with Mixed Menu' },
      { path: '/page-option/boxed-layout-with-mixed-menu', title: 'Boxed Layout with Mixed Menu' },
      { path: '/page-option/with-transparent-sidebar', title: 'Page with Transparent Sidebar' },
      { path: '/page-option/with-search-sidebar', title: 'Page with Search Sidebar', highlight: true }
    ]
  },
  { path: '/extra', icon: 'fa fa-gift', title: 'Extra', label: 'NEW',
    children: [
      { path: '/extra/timeline', title: 'Timeline' },
      { path: '/extra/coming-soon', title: 'Coming Soon Page' },
      { path: '/extra/search', title: 'Search Results' },
      { path: '/extra/invoice', title: 'Invoice' },
      { path: '/extra/error', title: '404 Error Page' },
      { path: '/extra/profile', title: 'Profile Page' },
      { path: '/extra/scrum-board', title: 'Scrum Board', highlight: true },
      { path: '/extra/cookie-acceptance-banner', title: 'Cookie Acceptance Banner', highlight: true },
      { path: '/extra/orders', title: 'Orders', highlight: true },
      { path: '/extra/order-details', title: 'Order Details', highlight: true },
      { path: '/extra/products', title: 'Products', highlight: true },
      { path: '/extra/product-details', title: 'Product Details', highlight: true }
    ]
  },
  // { path: '/user', icon: 'fa fa-key', title: 'Login & Register',
  //   children: [
  //     { path: '/user/login-v1', title: 'Login' },
  //     { path: '/user/login-v2', title: 'Login v2' },
  //     { path: '/user/login-v3', title: 'Login v3' },
  //     { path: '/user/register-v3', title: 'Register v3' }
  //   ]
  // },
]

export default Menu;
